import offerwiz from '../assets/images/offerwiz.png';
import rezztoran from '../assets/images/rezztoran.png';
import secureText from '../assets/images/secureText.webp';
import vecizeler from '../assets/images/vecizeler.webp';
import clipNest from '../assets/images/clipnest.png';
import clipNestIcon from '../assets/images/clipnest-icon.png';
import clipNestSettings from '../assets/images/clipnest-settings.png';
import clipNestEmojis from '../assets/images/clipnest-emojis.png';
import clipNestSymbols from '../assets/images/clipnest-symbols.png';

export const profile = {
  name: 'Salih Öz',
  email: 'slhoz.developer@gmail.com',
  location: { tr: 'İstanbul, Türkiye', en: 'Istanbul, Türkiye' },
  github: 'https://github.com/salihoz0',
  linkedin: 'https://www.linkedin.com/in/salih-%C3%B6z/',
  npm: 'https://www.npmjs.com/~salihoz0',
  website: 'https://salihoz.com.tr',
  resume: '/docs/cv.pdf',
};

export const content = {
  tr: {
    locale: 'TR',
    seo: {
      title: 'Salih Öz | Full-Stack Yazılımcı — React & Node.js',
      description: 'İstanbul merkezli full-stack yazılımcı Salih Öz; React, Node.js, React Native ve yapay zekâ API entegrasyonlarıyla web, mobil ve SaaS ürünleri geliştirir.',
      locale: 'tr_TR',
    },
    nav: { about: 'Hakkımda', services: 'Uzmanlık', work: 'Çalışmalar', openSource: 'Açık kaynak', experience: 'Deneyim', contact: 'İletişim' },
    hero: {
      eyebrow: 'SALİH ÖZ · FULL-STACK SOFTWARE ENGINEER',
      title: 'Karmaşık ürünleri',
      titleAccent: 'sade deneyimlere',
      titleEnd: 'dönüştürüyorum.',
      intro: 'React, React Native ve Node.js ile ölçeklenebilir ürünler geliştiriyor; ürün düşüncesini sağlam backend mimarisi ve özenli arayüzlerle birleştiriyorum.',
      primaryCta: 'Çalışmalarımı incele',
      secondaryCta: 'Birlikte çalışalım',
      availability: 'Yeni fikirlere ve iş birliklerine açık',
      scroll: 'Keşfet',
    },
    stats: [
      { value: '7 yıl', label: 'Yazılım geliştirme yolculuğu' },
      { value: '3', label: 'Yayımlanmış npm paketi' },
      { value: '7K+', label: 'Mobil uygulama indirmesi' },
      { value: '15', label: 'Dile ulaşan ürün deneyimi' },
    ],
    about: {
      kicker: '01 / YAKLAŞIM',
      title: 'Kodun ötesinde, çalışan sistemler.',
      body: [
        'Bilgisayar mühendisliği temelimi; SaaS ürünleri, masaüstü uygulamalar ve mobil deneyimler geliştirerek gerçek dünya problemlerine taşıyorum.',
        'Performans, gözlemlenebilirlik ve sürdürülebilirliği ürünün sonradan eklenen detayları değil, tasarım kararlarının doğal parçası olarak görüyorum.',
      ],
      principles: [
        { no: '01', title: 'Ürün odağı', text: 'Teknik kararları kullanıcı ve iş etkisiyle birlikte değerlendiririm.' },
        { no: '02', title: 'Ölçeklenebilir temel', text: 'Servisleri değişime dayanıklı, okunabilir ve ölçülebilir kurgularım.' },
        { no: '03', title: 'Uçtan uca sahiplenme', text: 'Fikirden dağıtıma kadar ürünün tüm yaşam döngüsünde sorumluluk alırım.' },
      ],
    },
    services: {
      kicker: '02 / NASIL KATKI SAĞLARIM',
      title: 'Fikirden yayına, ürünün tamamını sahipleniyorum.',
      intro: 'React veya Node.js ekosisteminde bir full-stack yazılımcı, React Native geliştirici ya da yapay zekâ servislerini gerçek ürün akışlarına bağlayacak bir ürün mühendisi arıyorsanız; araştırma, mimari, geliştirme ve yayına alma süreçlerinde katkı sağlayabilirim.',
      items: [
        {
          title: 'Web ve SaaS ürünleri',
          text: 'React ve TypeScript ile erişilebilir, responsive arayüzler; Node.js veya Django ile güvenilir API’ler ve sürdürülebilir ürün mimarileri geliştiriyorum.',
          tags: ['React', 'TypeScript', 'Node.js', 'SaaS'],
        },
        {
          title: 'AI destekli ürün akışları',
          text: 'Yapay zekâ ve LLM API’lerini teklif üretimi, içerik işleme ve iş otomasyonu gibi ölçülebilir kullanım senaryolarına güvenli biçimde entegre ediyorum.',
          tags: ['AI APIs', 'LLM entegrasyonu', 'Otomasyon'],
        },
        {
          title: 'Mobil uygulamalar',
          text: 'React Native ve Firebase ile kimlik doğrulama, gerçek zamanlı veri, bildirim, çevrimdışı deneyim ve mağaza dağıtımını kapsayan mobil ürünler geliştiriyorum.',
          tags: ['React Native', 'Firebase', 'Mobile'],
        },
        {
          title: 'Backend ve entegrasyonlar',
          text: 'PostgreSQL, Redis, mesaj kuyrukları, WebSocket ve belge işleme akışlarıyla performanslı, gözlemlenebilir ve değişime dayanıklı servisler kuruyorum.',
          tags: ['PostgreSQL', 'Redis', 'RabbitMQ', 'Real-time'],
        },
      ],
    },
    work: { kicker: '03 / SEÇİLİ ÇALIŞMALAR', title: 'Paylaşabildiğim bağımsız ürünler.', project: 'PROJE', live: 'Canlı ürünü aç', source: 'Kaynak kod', store: 'Mağazada gör', document: 'Proje dokümanı' },
    openSource: {
      kicker: '04 / AÇIK KAYNAK',
      title: 'Tekrar kullanılabilir araçlar üretiyorum.',
      intro: 'Ürün geliştirirken çözdüğüm problemleri, başka ekiplerin de kullanabileceği küçük ve odaklı paketlere dönüştürüyorum.',
      install: 'Kurulum komutunu kopyala',
      copied: 'Kopyalandı',
      npm: 'npm’de aç',
      repository: 'Repository',
      allRepos: 'Tüm GitHub projeleri',
      moreProjects: 'Diğer açık projeler',
    },
    experience: { kicker: '05 / YOLCULUK', title: 'Deneyim ve eğitim.', present: 'Günümüz' },
    contact: {
      kicker: '06 / İLETİŞİM',
      title: 'İyi bir fikri birlikte',
      titleAccent: 'çalışan ürüne',
      titleEnd: 'dönüştürelim.',
      body: 'Full-stack ürün geliştirme, mobil uygulama, backend mimarisi veya AI API entegrasyonu için İstanbul’dan yeni fikirlere ve teknik iş birliklerine açığım. Mesajınızı doğrudan ben okuyacağım.',
      email: 'E-posta gönder',
      linkedin: 'LinkedIn’de bağlan',
    },
    footer: 'Tasarladı ve geliştirdi',
    theme: 'Tema değiştir',
    language: 'Dili değiştir',
    menu: 'Menüyü aç',
  },
  en: {
    locale: 'EN',
    seo: {
      title: 'Salih Öz | Full-Stack Developer — React & Node.js',
      description: 'Istanbul-based full-stack developer Salih Öz builds web, mobile, and SaaS products with React, Node.js, React Native, and practical AI API integrations.',
      locale: 'en_US',
    },
    nav: { about: 'About', services: 'Expertise', work: 'Work', openSource: 'Open source', experience: 'Experience', contact: 'Contact' },
    hero: {
      eyebrow: 'SALİH ÖZ · FULL-STACK SOFTWARE ENGINEER',
      title: 'I turn complex products',
      titleAccent: 'into clear, useful',
      titleEnd: 'experiences.',
      intro: 'I build scalable products with React, React Native, and Node.js—combining product thinking, resilient backend architecture, and thoughtful interfaces.',
      primaryCta: 'Explore my work',
      secondaryCta: 'Let’s work together',
      availability: 'Open to new ideas and collaborations',
      scroll: 'Explore',
    },
    stats: [
      { value: '7 years', label: 'Building software' },
      { value: '3', label: 'Published npm packages' },
      { value: '7K+', label: 'Mobile app downloads' },
      { value: '15', label: 'Languages shipped in one product' },
    ],
    about: {
      kicker: '01 / APPROACH',
      title: 'Beyond code, systems that work.',
      body: [
        'I turn my computer engineering foundation into real-world outcomes across SaaS products, desktop tools, and mobile experiences.',
        'I treat performance, observability, and maintainability as design inputs—not details to bolt on after launch.',
      ],
      principles: [
        { no: '01', title: 'Product thinking', text: 'I connect technical decisions to user value and business outcomes.' },
        { no: '02', title: 'Scalable foundations', text: 'I design services to remain readable, measurable, and ready for change.' },
        { no: '03', title: 'End-to-end ownership', text: 'I stay accountable across the full journey from an idea to production.' },
      ],
    },
    services: {
      kicker: '02 / HOW I CAN HELP',
      title: 'Owning the product journey from idea to launch.',
      intro: 'If you are looking for a full-stack developer in the React or Node.js ecosystem, a React Native engineer, or a product engineer who can connect AI services to real product workflows, I can contribute across discovery, architecture, implementation, and delivery.',
      items: [
        {
          title: 'Web and SaaS products',
          text: 'I build accessible, responsive interfaces with React and TypeScript, dependable APIs with Node.js or Django, and maintainable foundations for evolving products.',
          tags: ['React', 'TypeScript', 'Node.js', 'SaaS'],
        },
        {
          title: 'AI-enabled product workflows',
          text: 'I integrate AI and LLM APIs into measurable use cases such as proposal generation, content processing, and workflow automation with production concerns in mind.',
          tags: ['AI APIs', 'LLM integration', 'Automation'],
        },
        {
          title: 'Mobile applications',
          text: 'I develop React Native and Firebase products covering authentication, real-time data, notifications, offline experiences, and app-store delivery.',
          tags: ['React Native', 'Firebase', 'Mobile'],
        },
        {
          title: 'Backend systems and integrations',
          text: 'I design performant, observable services with PostgreSQL, Redis, message queues, WebSockets, and document-processing workflows.',
          tags: ['PostgreSQL', 'Redis', 'RabbitMQ', 'Real-time'],
        },
      ],
    },
    work: { kicker: '03 / SELECTED WORK', title: 'Independent products I can share.', project: 'PROJECT', live: 'Visit live product', source: 'View source', store: 'View in store', document: 'Project document' },
    openSource: {
      kicker: '04 / OPEN SOURCE',
      title: 'Building reusable tools.',
      intro: 'I turn recurring product challenges into small, focused packages other engineering teams can use.',
      install: 'Copy install command',
      copied: 'Copied',
      npm: 'View on npm',
      repository: 'Repository',
      allRepos: 'All GitHub projects',
      moreProjects: 'More public projects',
    },
    experience: { kicker: '05 / JOURNEY', title: 'Experience and education.', present: 'Present' },
    contact: {
      kicker: '06 / CONTACT',
      title: 'Let’s turn a good idea',
      titleAccent: 'into a product',
      titleEnd: 'that works.',
      body: 'I am open to new ideas and technical collaborations from Istanbul across full-stack product development, mobile applications, backend architecture, and AI API integrations. Your message goes directly to me.',
      email: 'Send an email',
      linkedin: 'Connect on LinkedIn',
    },
    footer: 'Designed and built by',
    theme: 'Switch theme',
    language: 'Switch language',
    menu: 'Open menu',
  },
};

export const projects = [
  {
    no: '01', title: 'ClipNest', image: clipNest, icon: clipNestIcon, gallery: [clipNestSettings, clipNest, clipNestEmojis, clipNestSymbols], presentation: 'desktop', type: { tr: 'Masaüstü / Açık kaynak', en: 'Desktop / Open source' },
    description: {
      tr: 'Windows, macOS ve Linux için geliştirdiğim hızlı ve güvenli pano geçmişi yöneticisi. Arka planda hafif bir servis olarak çalışarak kopyalanan metinleri, biçimlendirilmiş içerikleri ve görselleri yerel olarak düzenler.',
      en: 'A fast, privacy-minded clipboard history manager I built for Windows, macOS, and Linux. It runs as a lightweight background service and organizes copied text, rich content, and images locally.',
    },
    features: {
      tr: ['Anlık arama, tür filtreleri ve favoriler', 'Global kısayollar ve sistem tepsisi entegrasyonu', 'Otomatik başlatma ve yapılandırılabilir akıllı temizlik'],
      en: ['Instant search, type filters, and favorites', 'Global shortcuts and system-tray integration', 'Auto-start and configurable smart cleanup'],
    },
    impact: { tr: 'Tek kod tabanı · 3 masaüstü platformu', en: 'One codebase · 3 desktop platforms' },
    technologies: ['Tauri', 'React', 'TypeScript', 'Rust'], source: 'https://github.com/salihoz0/ClipNest',
  },
  {
    no: '02', title: 'Vecizeler', image: vecizeler, presentation: 'device-native', type: { tr: 'Mobil ürün', en: 'Mobile product' },
    description: {
      tr: 'Kullanıcıların 800’den fazla vecizeyi keşfedebildiği, kaydedebildiği ve paylaşabildiği React Native uygulaması. Farklı soru-cevap modları, canlı eşleşmeler, seri (streak) ve rekabet mekanikleriyle gelişen ürün Google Play’de 7.000’den fazla indirmeye ulaştı.',
      en: 'A React Native app where users can discover, save, and share more than 800 quotes. Multiple quiz modes, live matches, streaks, and competitive mechanics have helped the evolving product reach 7,000+ Google Play downloads.',
    },
    features: { tr: ['800+ içerik, kaydetme ve gelişmiş arama', 'Farklı soru-cevap modları ve canlı eşleşmeler', 'Seri (streak), rekabet ve ilerleme mekanikleri', 'Firebase Auth, Storage ve push bildirimleri'], en: ['800+ entries, saved content, and advanced search', 'Multiple quiz modes and live matches', 'Streak, competition, and progression mechanics', 'Firebase Auth, Storage, and push notifications'] },
    impact: { tr: '7.000+ organik indirme', en: '7,000+ organic downloads' },
    technologies: ['React Native', 'Firebase', 'Push Notifications'], store: 'https://play.google.com/store/apps/details?id=com.vecizeler&hl=tr',
  },
  {
    no: '03', title: 'SecureText', image: secureText, presentation: 'device-shell', type: { tr: 'Güvenlik / Mobil', en: 'Security / Mobile' },
    description: {
      tr: 'Metinleri 20 farklı yöntemle şifreleyip güvenli biçimde paylaşmaya odaklanan mobil araç. Şifrelenmiş içerik yalnızca doğru çözme anahtarına sahip kullanıcılar tarafından okunabilir; arayüz 15 dili destekler.',
      en: 'A mobile utility focused on encrypting and securely sharing text through 20 different methods. Content can only be read with the correct decryption key, and the interface supports 15 languages.',
    },
    features: { tr: ['20 farklı şifreleme yöntemi', 'Anahtar tabanlı güvenli paylaşım', '15 dil ve Firebase bildirimleri'], en: ['20 encryption methods', 'Key-based secure sharing', '15 languages and Firebase notifications'] },
    impact: { tr: '15 dil · 20 şifreleme yöntemi', en: '15 languages · 20 encryption methods' },
    technologies: ['React Native', 'Firebase', 'Encryption', 'i18n'], store: 'https://play.google.com/store/apps/details?id=com.securetext&hl=tr',
  },
  {
    no: '04', title: 'OfferWiz AI', image: offerwiz, presentation: 'landscape', type: { tr: 'AI / B2B', en: 'AI / B2B' },
    description: {
      tr: 'B2B müşterileri için yapay zekâ destekli, kişiselleştirilmiş teklifler üreten freelance ürün çalışması. Tasarımcının hazırladığı Figma sistemini Material UI ile yeniden kullanılabilir React bileşenlerine ve üretime hazır responsive akışlara dönüştürdüm.',
      en: 'A freelance product that creates AI-assisted, personalized proposals for B2B customers. I translated the supplied Figma system into reusable Material UI components and production-ready responsive flows.',
    },
    features: { tr: ['Figma’dan piksel hassasiyetinde uygulama', 'Yeniden kullanılabilir React bileşen sistemi', 'Python backend ile AI destekli teklif akışı'], en: ['Pixel-precise Figma implementation', 'Reusable React component system', 'AI proposal flow backed by Python'] },
    impact: { tr: 'Tasarımdan üretime frontend teslimi', en: 'Design-to-production frontend delivery' },
    technologies: ['React', 'Material UI', 'Figma', 'Python'],
  },
  {
    no: '05', title: 'Rezztoran', image: rezztoran, presentation: 'device-shell', type: { tr: 'Mobil / Bitirme projesi', en: 'Mobile / Capstone' },
    description: {
      tr: 'Bilgisayar mühendisliği bitirme projesi olarak geliştirdiğimiz uçtan uca restoran rezervasyon sistemi. Kullanıcılar şehir ve kategoriye göre restoran keşfedebilir, detayları inceleyebilir, favori oluşturabilir, rezervasyon yapabilir ve deneyimlerini yorumlayabilir.',
      en: 'An end-to-end restaurant reservation system built as our computer engineering capstone. Users can discover venues by city and category, inspect details, save favorites, make reservations, and review their experiences.',
    },
    features: { tr: ['Şehir ve kategori tabanlı restoran keşfi', 'Rezervasyon, favoriler ve kullanıcı yorumları', 'Node.js API ve PostgreSQL veri modeli'], en: ['City and category-based discovery', 'Reservations, favorites, and user reviews', 'Node.js API with a PostgreSQL data model'] },
    impact: { tr: 'Mobil istemci + API + ilişkisel veri tabanı', en: 'Mobile client + API + relational database' },
    technologies: ['React Native', 'Node.js', 'PostgreSQL'], source: 'https://github.com/salihoz0/Rezztoran_mobile', doc: '/docs/rezztoranMobil.pdf',
  },
];

export const packages = [
  {
    name: 'tcmb-client', version: '1.0.4', command: 'npm i tcmb-client',
    description: { tr: 'TCMB EVDS API’sine tarihsel ve güncel döviz verileri için modern JavaScript istemcisi.', en: 'A modern JavaScript client for current and historical exchange-rate data from the TCMB EVDS API.' },
    npm: 'https://www.npmjs.com/package/tcmb-client', repository: 'https://github.com/salihoz0/TCMBClient', tags: ['Node.js', 'EVDS', 'API'],
  },
  {
    name: 'invoice-xml-to-pdf-converter', version: '1.0.6', command: 'npm i invoice-xml-to-pdf-converter',
    description: { tr: 'E-Arşiv, E-Fatura ve UBL XML belgelerini HTML veya PDF çıktısına dönüştüren Node.js aracı.', en: 'A Node.js utility that converts E-Archive, E-Invoice, and UBL XML documents into HTML or PDF.' },
    npm: 'https://www.npmjs.com/package/invoice-xml-to-pdf-converter', repository: 'https://github.com/salihoz0/InvoiceConverter', tags: ['Node.js', 'XML', 'PDF'],
  },
  {
    name: 'floating-react-calculator', version: '0.1.7', command: 'npm i floating-react-calculator',
    description: { tr: 'Gömülü, modal ve sürüklenebilir kullanım modlarına sahip özelleştirilebilir React hesap makinesi.', en: 'A customizable React calculator with embedded, modal, and draggable floating modes.' },
    npm: 'https://www.npmjs.com/package/floating-react-calculator', repository: 'https://github.com/salihoz0/react-calculator', tags: ['React', 'MUI', 'Component'],
  },
];

export const publicProjects = [
  { name: 'TCMBClient', language: 'JavaScript', href: 'https://github.com/salihoz0/TCMBClient', description: { tr: 'TCMB EVDS için açık kaynak istemci.', en: 'Open-source client for the TCMB EVDS.' } },
  { name: 'InvoiceConverter', language: 'Java / JavaScript', href: 'https://github.com/salihoz0/InvoiceConverter', description: { tr: 'XML faturalar için dönüştürme aracı.', en: 'Conversion tooling for XML invoices.' } },
  { name: 'ilan-ver-backend', language: 'JavaScript', href: 'https://github.com/salihoz0/ilan-ver-backend', description: { tr: 'Eğitim amaçlı ilan platformu API’si.', en: 'An educational listing-platform API.' } },
];

export const journey = [
  {
    period: { tr: 'Kasım 2023 — Günümüz', en: 'Nov 2023 — Present' },
    role: { tr: 'Full-Stack Developer', en: 'Full-Stack Developer' },
    company: 'HIGHTECH Natural Bilişim A.Ş.',
    description: { tr: 'FinTech ve muhasebe otomasyonu alanlarında React ve Node.js ekosistemiyle ürün geliştirme; belge işleme akışları, gerçek zamanlı servisler, çok kanallı bildirim sistemleri, iş kuyrukları ve masaüstü entegrasyonları.', en: 'Product engineering across FinTech and accounting automation with React and Node.js, including document-processing workflows, real-time services, multi-channel notifications, job queues, and desktop integrations.' },
    tags: ['React', 'Node.js', 'PostgreSQL', 'Redis', 'RabbitMQ'],
  },
  {
    period: { tr: 'Ağustos 2023 — Aralık 2023', en: 'Aug 2023 — Dec 2023' },
    role: { tr: 'Freelance Software Developer', en: 'Freelance Software Developer' },
    company: 'Independent',
    description: { tr: 'Figma’dan üretime React arayüzleri, Django servisleri ve yapay zekâ entegrasyonları geliştirme.', en: 'Delivered production React interfaces from Figma, Django services, and AI integrations.' },
    tags: ['React', 'Django', 'Python', 'AI APIs'],
  },
  {
    period: { tr: '2019 — Günümüz', en: '2019 — Present' },
    role: { tr: 'Bağımsız Ürün Geliştirici', en: 'Independent Product Builder' },
    company: 'Open source & side projects',
    description: { tr: 'Mobil uygulamalar, geliştirici araçları, npm paketleri ve açık kaynak masaüstü ürünleri tasarlama ve yayımlama.', en: 'Designing and shipping mobile apps, developer tools, npm packages, and open-source desktop products.' },
    tags: ['React Native', 'Tauri', 'npm', 'Open Source'],
  },
  {
    period: { tr: '2019 — 2023', en: '2019 — 2023' },
    role: { tr: 'Bilgisayar Mühendisliği, Lisans', en: 'BSc, Computer Engineering' },
    company: 'Trakya Üniversitesi',
    description: { tr: 'Bilgisayar mühendisliği lisans eğitimi ve restoran rezervasyon sistemi bitirme projesi.', en: 'Computer engineering degree and an end-to-end restaurant reservation capstone.' },
    tags: ['Computer Science', 'Software Engineering'],
  },
];

export const stack = ['JavaScript', 'TypeScript', 'React', 'React Native', 'Node.js', 'Fastify', 'PostgreSQL', 'Prisma', 'Redis', 'RabbitMQ', 'BullMQ', 'Socket.io', 'Electron', 'Tauri', 'Firebase', 'Docker'];
